// source: https://github.com/andymantell/node-wpautop
// Note: this is a port of the wordpress php function wpautop

export function wpautop(pee: string): string {
  const preTags: Record<string, string> = {};
  if (pee.trim() === '') {
    return '';
  }

  pee = pee + '\n'; // just to make things a little easier, pad the end
  if (pee.includes('<pre')) {
    const peeParts = pee.split('</pre>');
    const lastPee = peeParts.pop();
    pee = '';
    peeParts.forEach(function (peePart, index) {
      const start = peePart.indexOf('<pre');

      // Malformed html?
      if (start === -1) {
        pee += peePart;
        return;
      }

      const name = '<pre wp-pre-tag-' + index + '></pre>';
      preTags[name] = peePart.substr(start) + '</pre>';
      pee += peePart.substr(0, start) + name;
    });

    pee += lastPee;
  }

  pee = pee.replace(/<br \/>\s*<br \/>/, '\n\n');

  // Space things out a little
  const allblocks =
    '(?:table|thead|tfoot|caption|col|colgroup|tbody|tr|td|th|div|dl|dd|dt|ul|ol|li|pre|form|map|area|blockquote|address|math|style|p|h[1-6]|hr|fieldset|legend|section|article|aside|hgroup|header|footer|nav|figure|figcaption|details|menu|summary)';
  pee = pee.replace(new RegExp('(<' + allblocks + '[^>]*>)', 'gmi'), '\n$1');
  pee = pee.replace(new RegExp('(</' + allblocks + '>)', 'gmi'), '$1\n\n');
  pee = pee.replace(/\r\n|\r/, '\n'); // cross-platform newlines

  if (pee.includes('<option')) {
    // no P/BR around option
    pee = pee.replace(/\s*<option'/gim, '<option');
    pee = pee.replace(/<\/option>\s*/gim, '</option>');
  }

  if (pee.includes('</object>')) {
    // no P/BR around param and embed
    pee = pee.replace(/(<object[^>]*>)\s*/gim, '$1');
    pee = pee.replace(/\s*<\/object>/gim, '</object>');
    pee = pee.replace(/\s*(<\/?(?:param|embed)[^>]*>)\s*/gim, '$1');
  }

  if (pee.includes('<source') || pee.includes('<track')) {
    // no P/BR around source and track
    pee = pee.replace(/([<[](?:audio|video)[^>\]]*[>\]])\s*/gim, '$1');
    pee = pee.replace(/\s*([<[]\/(?:audio|video)[>\]])/gim, '$1');
    pee = pee.replace(/\s*(<(?:source|track)[^>]*>)\s*/gim, '$1');
  }

  pee = pee.replace(/\n\n+/gim, '\n\n'); // take care of duplicates

  // make paragraphs, including one at the end
  const pees = pee.split(/\n\s*\n/);
  pee = '';
  pees.forEach(function (tinkle) {
    pee += '<p>' + tinkle.replace(/(^\s+)|(\s+$)/g, '') + '</p>\n';
  });

  pee = pee.replace(/<p>\s*<\/p>/gim, ''); // under certain strange conditions it could create a P of entirely whitespace
  pee = pee.replace(/<p>([^<]+)<\/(div|address|form)>/gim, '<p>$1</p></$2>');
  pee = pee.replace(new RegExp('<p>s*(</?' + allblocks + '[^>]*>)s*</p>', 'gmi'), '$1'); // don't pee all over a tag
  pee = pee.replace(/<p>(<li.+?)<\/p>/gim, '$1'); // problem with nested lists
  pee = pee.replace(/<p><blockquote([^>]*)>/gim, '<blockquote$1><p>');
  pee = pee.replace(/<\/blockquote><\/p>/gim, '</p></blockquote>');
  pee = pee.replace(new RegExp('<p>s*(</?' + allblocks + '[^>]*>)', 'gmi'), '$1');
  pee = pee.replace(new RegExp('(</?' + allblocks + '[^>]*>)s*</p>', 'gmi'), '$1');
  pee = pee.replace(new RegExp('(</?' + allblocks + '[^>]*>)s*<br />', 'gmi'), '$1');
  pee = pee.replace(/<br \/>(\s*<\/?(?:p|li|div|dl|dd|dt|th|pre|td|ul|ol)[^>]*>)/gim, '$1');
  pee = pee.replace(/\n<\/p>$/gim, '</p>');

  if (Object.keys(preTags).length) {
    pee = pee.replace(new RegExp(Object.keys(preTags).join('|'), 'gi'), function (matched) {
      return preTags[matched];
    });
  }

  // Replace any blank lines
  pee = pee.replace(/\n\s*\n/gim, '\n');

  return pee;
}
